export const transformSentenceToUrl = (text: string): string => {
    const trimmedString = text.trim();
    return trimmedString.replace(/\s+/g, '-').toLowerCase();
};
